import { typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const InfoTitleStyled = styled.p`
  ${typography.bold[18]};
  margin: 0 0 8rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TotalAmountStyled = styled.b`
  margin: 0 0.5rem;
`;

export const EmailsListStyled = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  padding: 0;
  margin: 0;
  list-style: none;
`;
